<div class="card">
    <div class="card-header">
        <h4>Add Product Category</h4>
    </div>
    <form #categoryAdd="ngForm" (ngSubmit)="addCategory(categoryAdd.value)" [formGroup]="addCategoryForm">
    <div class="row">
        <div class="col-sm-6 mb-sm-0">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body ">
                <img [src]="selectedFile"  width="150" height="150" class="rounded-circle" alt="category Image">
                <br>
                <div class="custom-file">
                  <div class="file btn btn-lg bg-primary">
                Upload &nbsp;<i class="fa fa-upload"></i>
                <input type="file" [ngClass]="{'is-invalid':submitted && addCategoryForm.controls.categoryImage.errors}" accept="image/*" (change)="setCategoryProfile($event)" name="categoryImage">
                </div>
                </div>
                <div class="invalid-feedback mt-2" style="display: block;" id="fileNameDisplay"
                            *ngIf="submitted && addCategoryForm.controls.categoryImage.errors">
                            <div *ngIf="addCategoryForm.controls.categoryImage.errors?.required">
                              Icon is required.
                            </div>
                        </div>
                    
                <a href="javascript:void(0)" *ngIf="addCategoryForm.get('categoryImage')?.valid" (click)="removeFile()"
                            class="position-absolute" style="top: 10px; right: 180px; color: #dc3545;">
                            <i class="fa fa-times-circle fa-lg"></i>
                </a>
              
                <p style="font-size: 13px; margin-top: 4px;">PNG/JPG with max size 50 KB allowed.</p>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body">
                <br>
                <br>
                <p class="card-text">Here's how it will look on Mobile App </p>
                <br>
                <img src="assets\images\app-productCategory.png" width="300" height="80" class=" mb-3" alt="...">
            </div>
          </div>
        </div>
    </div>
    <hr >
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body">
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="categoryName">Category Name <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="categoryName" autocomplete="off" class="form-control" required formControlName="categoryName" placeholder="Enter Category Name" [ngClass]="{'is-invalid':submitted && addCategoryForm.controls.categoryName.errors}" (keypress)="onCategoryNameKeyPress($event)" ngModel name="categoryName">
                    <div class="invalid-feedback">
                      Category is required
                      </div>
                </div>
                <div class="form-group col-md-3">
                    <label class="col-form-label" for="categoryDesc">Category Description <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" class="form-control" autocomplete="off" required formControlName="categoryDesc" placeholder="Enter Category Description" [ngClass]="{'is-invalid':submitted && addCategoryForm.controls.categoryDesc.errors}" (keypress)="onCategoryDescKeyPress($event)" ngModel name="categoryDesc">
                    <div class="invalid-feedback">
                            Category Description is required
                    </div>
                </div>
                
            </div>
            <!-- <div class="row d-flex">
                <div class="form-group col-md-3 ">
                  <label class="col-form-label" for="status">Status <span aria-hidden="true"
                          class="symbol required" style="color:red;">*</span>
                  </label>
                  <ng-select id="status" formControlName="status" placeholder="Select Status" required [ngClass]="{'is-invalid':submitted && addCategoryForm.controls.status.errors}"  name="status">
                      <ng-option value="ACTIVE">Active</ng-option>
                      <ng-option value="INACTIVE">Inactive</ng-option>
                    </ng-select>
                  <div class="invalid-feedback">
                      <div >
                          Status is required
                      </div>
                  </div>
              </div>
            </div> -->
            <div class="row d-flex">
                <div class="form-group col-md-12 text-right">
                    <button class="btn btn-primary" type="submit">Save</button>
                    <button class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>   
  </form>
</div>